import { render, staticRenderFns } from "./InfocardOrderModal.vue?vue&type=template&id=2d851ad3&scoped=true&"
import script from "./InfocardOrderModal.vue?vue&type=script&lang=js&"
export * from "./InfocardOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./InfocardOrderModal.vue?vue&type=style&index=0&id=2d851ad3&lang=scss&scoped=true&"
import style1 from "./InfocardOrderModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d851ad3",
  null
  
)

export default component.exports